import studio4 from "@/assets/sign-up/studio-4.png";
import logo from "@/assets/logo-cineblocks-1.svg";
import { Link } from "wouter";
import { SignUpForm } from "./components/form";
import { SplitScreen } from "@/components/ui/split-screen";

export default function SignUp() {
  return (
    <SplitScreen
      firstComponent={
        <div className="h-full flex items-center justify-center">
          <img
            src={studio4}
            alt="Estúdio 4"
            className="rounded-2xl h-full 2xl:h-3/4 w-10/12 object-cover"
          />
        </div>
      }
      secondComponent={
        <div className="h-full flex flex-col items-center lg:items-start justify-center">
          <div className="max-w-lg w-full space-y-4">
            <div className="text-center">
              <div className="flex items-center justify-center gap-2">
                <img src={logo} alt="Logo Cineblocks" className="w-8" />
                <h1 className="text-3xl font-bold">cineblocks</h1>
              </div>
              <p className="text-xl mt-2">Cadastre-se no Sistema Cineblocks</p>
              <p className="text-sm text-label mt-1">
                Cadastre-se com seu nome, e-mail e senha.
              </p>
            </div>

            <SignUpForm />

            <div className="flex flex-col gap-2">
              <div>
                <p className="text-sm text-label">
                  Ao continuar você concorda com nossos{" "}
                  <a href="#" className="hover:underline">
                    Termos de Serviço
                  </a>{" "}
                  e que leu e entendeu nossa{" "}
                  <a href="#" className="hover:underline">
                    Política de Privacidade
                  </a>
                </p>
              </div>

              <div>
                <p className="text-xs text-label">
                  Já tem uma conta?{" "}
                  <Link href="/login" className="text-primary hover:underline">
                    Entrar
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
}